/** @private wantedly/ui の内部以外では使わない  */
export var shapeNames = ["R0", "R2", "R4", "R16", "R100"];
export var getRadius = function getRadius(shape) {
  switch (shape) {
    case "R0":
      return "0px";

    case "R2":
      return "2px";

    case "R4":
      return "4px";

    case "R16":
      return "16px";

    case "R100":
      return "9999vmax";
  }
};
//# sourceMappingURL=shapes.js.map